import React, { FC } from 'react'

import { ProfileName } from 'components/presentational/ProfileName/ProfileName'
import { ProfileNameDeleted } from 'components/presentational/ProfileNameDeleted/ProfileNameDeleted'

export const SwitchName: FC<{
  name: string
  age: number
  onlineStatus?: boolean
  verifiedPhotos?: boolean
  deleted?: boolean
  hidden?: boolean
}> = ({ name, age, onlineStatus, verifiedPhotos, deleted, hidden }) => {
  if (deleted || hidden) {
    return <ProfileNameDeleted />
  }

  return (
    <ProfileName
      fullName={name}
      age={age}
      online={onlineStatus}
      statusVerification={verifiedPhotos}
    />
  )
}
